import React from 'react';

export const SearchIcon: React.FC = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.5" r="4.5" stroke="#394577" strokeWidth="2" />
      <rect
        x="12"
        y="13.4141"
        width="2"
        height="9"
        rx="1"
        transform="rotate(-45 12 13.4141)"
        fill="#394577"
      />
    </svg>
  );
};
